import React from "react"
import Wrapper from "../components/Wrapper"
export default function DashboardPage() {
  return (
    <Wrapper>
      <h1 className="text-6xl font-black p-5">Welcome to sellB Dashboard</h1>
    </Wrapper>
  )
}
